import React from 'react';

import DropdownSelections from 'app/collections/dropdown_selections';
import ApiModeSelection from 'app/models/api_mode_selection';
import CashFlowReport from 'app/models/cash_flow_report';
import DateRange, { DATERANGE_PARAM_TYPES } from 'app/models/date_range';
import UTCOffsetSelection from 'app/models/utc_offset_dropdown_selection';

import Base from 'app/views/base';
import DatepickerRangeView from 'app/views/datepicker_range_view';
import SelectorView from 'app/views/selector_view';

import PageHeader from 'app/components/page_header_react';
import RequestReportView from 'app/components/request_report';

import tmpl from './template';

export const MIN_DATERANGE_DATE = '2016-11-01';

export default Base.extend({
  compiledTemplate: tmpl,
  className: 'cash-flow',

  initialize({ query = {} }) {
    this.apiModeSelection = new ApiModeSelection({ mode: 'production' });
    this.dateRange = new DateRange({ paramType: DATERANGE_PARAM_TYPES.DATE });
    this.utcOffsetSelection = new UTCOffsetSelection();
    this.dropdownSelections = new DropdownSelections(
      [this.utcOffsetSelection],
      { initialChoices: query[this.className], urlParamKey: this.className },
    );

    this.addReactComponent('header', <PageHeader name="Cash Flow" />);
    this.addSubview('datePickers', '#cash_flow_daterange_pickers', new DatepickerRangeView({
      model: this.dateRange, minDate: MIN_DATERANGE_DATE,
    }));
    this.addSubview('utcOffsetSelector', '#utc_offset_selector', new SelectorView({ model: this.utcOffsetSelection }));
    this.addSubview('requestCashFlowReport', '#request_cash_flow_report', new RequestReportView({
      ReportClass: CashFlowReport,
      dateRange: this.dateRange,
      apiModeSelection: this.apiModeSelection,
      dropdownSelections: this.dropdownSelections,
    }));
  },
});



// WEBPACK FOOTER //
// ./app/components/pages/billing/cash_flow/index.jsx